<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none" style="flex-shrink: 0">
    <circle opacity="0.4" cx="2" cy="2" r="2" fill="#747474" />
  </svg>
</template>

<script>
export default {
  name: 'DotSeparator'
};
</script>
